/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.89 14.84',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M18.39 0H.5a.5.5 0 00-.5.5v11.36a.5.5 0 00.5.5h17.89a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zm-.5 11.36H1V1h16.89zm-4 2.48H5a.5.5 0 000 1h8.9a.5.5 0 000-1z" _fill="#c4c4c4"/><path pid="1" _fill="#74777a" d="M3.13 3.4h12.48v2.58H3.13z"/></g></g>'
  }
})
